import blueBackground from './images/blue-background.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
import { useNavigate } from 'react-router-dom'
import { Color, RoutePath } from '../../constants'
import NavBar from '../NavBar'
import { forwardRef } from 'react'
import downArrowIcon from './images/down-arrow.svg'

import {
  config,
  useChain,
  useInView,
  useSpring,
  animated,
} from '@react-spring/web'
import Button from '../shared/Button'

const Intro = forwardRef((_props, ref) => {
  const navigate = useNavigate()
  const [inViewRef, inView] = useInView({ once: true })
  const scrollCTATrail = useSpring({
    opacity: inView ? 1 : 0,
    duration: 1000,
    config: config.molasses,
  })
  const [scrollCTALoopTrail] = useSpring(
    () => ({
      from: { y: 0 },
      to: [{ y: 0 }, { y: 8 }, { y: 0 }],
      config: {
        mass: 6,
        tension: 280 / 2,
        friction: 70,
      },
      loop: true,
    }),
    []
  )

  useChain([])
  return (
    <section id="intro" className="bg-black h-full relative" ref={ref as any}>
      <div className="p-8">
        <NavBar />
        <div className="w-fit m-auto">
          <div className="flex flex-col gap-16 items-center mt-64">
            <div className="flex flex-col gap-4 items-center">
              <h4 className="md:text-[48px] lg:text-[72px] leading-[80px] font-decimal text-white">
                Mapping the U.S.
              </h4>
              <div className="relative">
                <img
                  src={blueBackground}
                  alt="blue squiggly line"
                  className="w-full"
                />
                <h4 className="md:text-[48px] lg:text-[72px] md:leading-[64px] lg:leading-[80px] font-decimal text-white font-bold absolute top-[0px] left-[0px] w-full text-center">
                  Reparations Movement
                </h4>
              </div>
            </div>
            <Button
              onClick={() => navigate(RoutePath.Map)}
              textColor={Color.White}
              backgroundColor={Color.Black}
            >
              <p className="text-[16px] uppercase flex-1 font-bold">
                Skip to Map View
              </p>
              <FontAwesomeIcon icon={faArrowRight} />
            </Button>
            <p className="font-decimal uppercase text-[18px] text-white">OR</p>
            <animated.div
              ref={inViewRef}
              className="flex items-center mb-8 z-[151]"
              style={scrollCTATrail}
            >
              <animated.div
                className="flex gap-4 items-center"
                style={scrollCTALoopTrail}
              >
                <img
                  src={downArrowIcon}
                  alt="mouse with instructions to scroll"
                />
                <p className="text-white text-[14px] font-decimal">
                  Scroll to Explore <br />
                  More About The <br />
                  Mapping Process
                </p>
              </animated.div>
            </animated.div>
          </div>
        </div>
      </div>
    </section>
  )
})

export default Intro
